<div class="network-active-button" [class.active]="active">
  <ng-content></ng-content>
  <div class="overlay" *ngIf="active" [@fadeInOut]>
    <mat-spinner diameter="30"> </mat-spinner>
  </div>
</div>
